import { useState } from "react"
import moment from "moment"
import { useForm } from "react-hook-form"
import { useUploadFile } from "../../core/utils/hooks/uploadItem"
import { customToast } from "../../components/Toast"
import ContentPageScreen from "../../screen/ContentPageScreen"
import Send from "../../core/communication"
import { useLoadDataDwContent } from "../../core/utils/hooks/useDwContentData"

const ContentPageContainer = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [selectedsUsers, setSelectedsUsers] = useState([])
  const [oldUserData, setOldUserData] = useState([])
  const [filter, setFilter] = useState({})
  const [searchTerm, setSearchTerm] = useState("")
  const [errorImage, setErrorImage] = useState(false)
  const [isLoadingSave, setIsLoadingSave] = useState(false)
  const [processingFile, setProcessingFile] = useState(false)
  const [uploaded, setUploaded] = useState(false)
  const [hasFilter, setHasFilter] = useState(false)
  const [evidenceImage, setEvidenceImage] = useState({})
  const [values, setValues] = useState({})
  const {dw, tagsProject, isLoading, reload, isFetching, lastUpdated} = useLoadDataDwContent()

  const { control, handleSubmit, register, setValue } = useForm({
    mode: "onBlur",
  })

  const openModalEdit = (data) => {
    if(typeof data === "string"){
      const filteredOldUser = dw.filter((item) => item.ID === data)[0]
      setOldUserData([filteredOldUser || {}])
      setValue("observation", filteredOldUser?.Pergunta_codigo?.TEMACONTEUDO)
      setValue("application", filteredOldUser?.Pergunta_codigo?.NOTA)
    }
    else {
      const filteredOldUser = dw.filter((item) => data.some(selected => selected.ID === item.ID))
      setOldUserData(filteredOldUser)
      setValue("observation", "")
      setValue("application", "")
    }
    setModalIsOpen(true)
  }

  // const subItems = dw.map((item) => ({ name: item.Produtor, tecnico: item.Tecnico, nota: item.Resposta }));

  const onSearchContent = (e) => {
    setSearchTerm(e.target.value)
  }


  const filteredContent = () => {
    let filterContent = dw?.filter(
      (item) =>
        item.Produtor?.toLowerCase().indexOf(searchTerm?.toLowerCase()) !== -1 ||
        item.Tecnico?.toLowerCase().indexOf(searchTerm?.toLowerCase()) !== -1,
    )

    if (filter.nota && filter.nota.value) {
      filterContent = filterContent.filter((item) =>
        `${item.Pergunta_codigo?.NOTA}`.toLowerCase().includes(filter.nota?.value),
      )
    }

    if (filter.tag && filter.tag.value) {
      filterContent = filterContent.filter(
        (item) =>
          item.tag_user.filter((tag) => tag.id === filter.tag.value)[0],
      )
    }
    

    if (values.year && values.year.length != "") {
      const [startDate, endDate] = values.year.split('|')

      filterContent = filterContent.filter(
        (item) =>
          item.realInicio >= startDate && item.realInicio <= endDate,
      )
    }

    return filterContent
  }

  const onChangeImage = (e) => {
    const files = e.target.files
    const fileReader = new FileReader()

    fileReader.fileName = files[0]?.name
    fileReader.readAsDataURL(files[0])

    fileReader.onload = (event) => {
      const fileName = event.target?.fileName || ""
      const newDataFile = { data: event.target.result, type: fileName.split(".")[1] }

      setEvidenceImage(newDataFile)
      setUploaded(true)
    }
    e.target.value = null
  }

  const onChange = (field) => {
    return (value) => {
      setValues((values) => ({ ...values, [field]: value }))
    }
  }

  const sendItems = async (data) => {
    setProcessingFile(true)
    const imageUpload = await useUploadFile(
      evidenceImage.data || "",
      setErrorImage,
      evidenceImage?.type,
    )
    setProcessingFile(false)

    const valuesToSend = oldUserData.length && oldUserData.map(item => {
      return {
        formSubmissionId: item?.Envio_Formulario,
        assistanceId: item?.Atendimento,
        formWizardTitle: item?.Etapa,
        farmer: item?.ID,
        question: item?.Pergunta,
        answer: {
          TEMACONTEUDO: data?.observation,
          NOTA: data?.application || item?.Pergunta_codigo?.NOTA,
          EVIDCONTEUDO: imageUpload || "",
        },
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      }
    })

    setIsLoadingSave(true)
    const response = await Send.post("/forms-submissions/copy", valuesToSend)
    setOldUserData([])
    setValue("observation", "")
    setValue("application", "")
    setIsLoadingSave(false)
    setModalIsOpen(false)
    setUploaded(false)
    setSelectedsUsers([])

    if (response.status === "error") {
      customToast("Erro ao criar cópia do atendimento", "error")
    }
    else {
      customToast("Cópia do atendimento criada com sucesso", "success")
    }
  }


  const countNotes = () => {
    const data = dw
    let notes = []

    Array.isArray(data) && data.length && 
    data.map(project => notes.push({
      notas: project.Pergunta_codigo.NOTA
    }))

    const filterNotes = (key) => {
      return notes?.filter(item => item.notas === key).length || 0
    }

    return {
      note0: filterNotes('0'),
      note2: filterNotes('2'),
      note3: filterNotes('3'),
      note5: filterNotes('5')
    }
  }

  const handleSelectedList = async (data) => {

    if (Array.isArray(data)) {
      setSelectedsUsers(current => current.length ? [] : data);
    } else {
      const hasValueIndex = selectedsUsers.findIndex(item => item.id === data.id);
    
      if (hasValueIndex !== -1) {
        setSelectedsUsers(current => {
          const updatedUsers = [...current];
          updatedUsers.splice(hasValueIndex, 1);
          return updatedUsers;
        });
      } else {
        setSelectedsUsers(current => [data, ...current]);
      }
    }
  }

  return (
    <>
      <ContentPageScreen
        {...{
          tagsProject,
          openModalEdit,
          modalIsOpen,
          setModalIsOpen,
          onSearchContent,
          searchTerm,
          setFilter,
          filter,
          onChangeImage,
          onChange,
          isLoading,
          isLoadingSave,
          register,
          control,
          values,
          processingFile,
          uploaded,
          handleSelectedList,
          selectedsUsers,
          isFetching, 
          lastUpdated, 
          reload,
          hasFilter
        }}
        sendItems={handleSubmit(sendItems)}
        data={filteredContent() || dw}
        countNotes={countNotes()}
      />
    </>
  )
}

export default ContentPageContainer
